<template>
  <div>
    <v-card max-width="80%" class="mx-auto">
      <v-toolbar color="headeryfooter" dark>
        <v-app-bar-nav-icon></v-app-bar-nav-icon>
        <v-toolbar-title>Reportes</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field placeholder="Buscar" dense outlined hide-details single-line v-model="filtro"></v-text-field>
        <v-btn icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-list>
        <v-list-item
          v-for="reporte in filtrada"
          :key="reporte.id_reporte"
          @click="selected=reporte; $vuetify.goTo(target, options)"
        >
          <v-list-item-avatar>
            <v-btn icon class="blue-grey lighten-5">
              <v-icon>mdi-file-chart</v-icon>
            </v-btn>
          </v-list-item-avatar>
          <v-list-item-content>
            <p class="font-weight-bold">{{reporte.nombre}}</p>
            <p class="text--secondary">{{reporte.descripcion_reporte}}</p>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
    <v-container fluid id="report">
      <v-card dark color="fondomenu" v-if="selected != ''">
        <v-card-title>{{selected.nombre}}</v-card-title>
        <v-card-text>
          <div class="resp-container">
            <iframe
              class="resp-iframe"
               :src="'https://oseiv.ddns.net/Reportes/Default.aspx?rpt=' + selected.url + '&rs:embed=true'"
              allowfullscreen
            ></iframe>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
//:src="selected.url + '?rs:embed=true&dsu:ObraSocial_V=Administrator&dsp:ObraSocial_V=1planVMW'"
export default {
  data() {
    return {
      filtro: "",
      selected: "",
      options: {
        duration: 500
      },
      target: "#report"
    };
  },
  computed: {
    ...mapState("reportes", ["Lista"]),
    filtrada() {
      return this.Lista.filter(
        x =>
          x.nombre.toUpperCase().indexOf(this.filtro.toUpperCase()) > -1 ||
          x.descripcion_reporte
            .toUpperCase()
            .indexOf(this.filtro.toUpperCase()) > -1
      );
    }
  },
  methods: {
    ...mapActions("reportes", ["set"])
  },
  mounted() {
    this.set();
  }
};
</script>

<style>
.resp-container {
  position: relative;
  overflow: hidden;
  padding-top: 45%;
}
.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 500px;
  border: 0;
  background-color: white;
}
</style>